import React from "react";

interface ButtonProps {
  label: any;
  onClick?: () => void;
  className?: string; // Optional custom styles
  type?: any; // Optional custom styles
}

const MainButton: React.FC<ButtonProps> = ({
  label,
  onClick,
  className,
  type,
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      className={`px-4 py-2 bg-primary text-white rounded  focus:outline-none focus:ring-0 ${className}`}
    >
      {label}
    </button>
  );
};

export default MainButton;
